@if (loadingPageData || !isPageReady) {
    <div class="loading-page-data"></div>
}
@if (isBookingEngineWidget && !widgetConfig.noOnDesktop) {
    <div class="widget-container" id="inline">
        <lib-babylon-booking-widget
            widgetId="widget-search"
            [hotelId]="widgetConfig.hotelId"
            [ticker]="ticker$()?.bodyextra?.nameIdentifier ?? ''"
            [type]="widgetConfig.type"
            [engine]="widgetConfig.engine"
            theme="light"
            [showPrice]="widgetConfig.showPrice"
            [defaultAdults]="widgetConfig.defaultAdults"
            [defaultChildren]="widgetConfig.defaultChildren"
            [currency]="widgetConfig.currency"
            [locale]="languagesData?.selected?.code"
            layout="inline"
            [baseUrl]="
                widgetConfig.engine !== 'witbooking'
                    ? widgetConfig.baseUrl
                    : widgetConfig.baseUrl + languagesData?.selected?.code + '/'
            "
            [urlChain]="widgetConfig.urlChain"
            [urlHotel]="widgetConfig.urlHotel"
            [showChildAges]="widgetConfig.showChildAges"
            [maxRooms]="widgetConfig.maxRooms"
            [showAllHotelsOption]="widgetConfig.showAllHotelsOption"
            ngSkipHydration
        ></lib-babylon-booking-widget>
    </div>
}

@if (isBookingEngineWidgetDynamic) {
    <div
        widgetMotorMoveToHeader="#widget-search"
        headerSlotSelector=".mdl-header .m-motor"
    ></div>
}

@if (!inComingSoon) {
    @if (!minMobileHeader && usesLegacyHeader) {
        <div class="header-mobile-container">
            @if (headerData6) {
                <lib-babylon-header-mobile
                    [lang]="headerData6.lang"
                    [menu]="headerData6.menu"
                    [menuInfo]="headerData6.menuInfo"
                    [linkLogo]="headerData6.linkLogo"
                    [logos]="logos"
                    [btnBook]="headerData6 | btnBook: !isBookingEngineEnabled"
                    [links]="headerData6.links"
                    [shop]="headerData6.shop"
                    [news]="headerData6.news"
                    [engineExtern]="engine_extern"
                    [multipleMotorsModal]="multipleMotorsModal"
                    (openEngine)="openEngineModal()"
                    (openLanguages)="openLanguagesModal(1)"
                    (openNews)="openNewsletterModal()"
                    (modalClick)="onOpenGlobalModal($event)"
                    (openModalMultMotors)="openModalMultMotors()"
                ></lib-babylon-header-mobile>
            }
        </div>
    }

    @if (minMobileHeader || usesSelfResponsiveHeader) {
        <div
            class="header-desktop-container"
            [ngClass]="{
                'no-on-mobile': usesLegacyHeader,
            }"
        >
            @switch (headerVersion) {
                @case ('headerBookShow') {
                    <ng-container
                        [ngTemplateOutlet]="headerBookShow"
                    ></ng-container>
                }
                @case ('headerClear') {
                    <ng-container
                        [ngTemplateOutlet]="headerClear"
                        [ngTemplateOutletContext]="{ engineShow: false }"
                    ></ng-container>
                }
                @case ('headerClearEngineShow') {
                    <ng-container
                        [ngTemplateOutlet]="headerClear"
                        [ngTemplateOutletContext]="{ engineShow: true }"
                    ></ng-container>
                }
                @case ('headerMenuCenter') {
                    <ng-container
                        [ngTemplateOutlet]="headerMenuCenter"
                    ></ng-container>
                }
                @case ('headerMenuShow') {
                    <ng-container
                        [ngTemplateOutlet]="headerMenuShow"
                    ></ng-container>
                }
                @case ('headerMenuShowEngineShow') {
                    <ng-container
                        [ngTemplateOutlet]="headerMenuShow"
                        [ngTemplateOutletContext]="{ engineShow: true }"
                    ></ng-container>
                }
                @case ('headerCenterBookShow') {
                    <ng-container
                        [ngTemplateOutlet]="headerCenterBookShow"
                    ></ng-container>
                }
                @case ('C4MeTxtSvgCtaComponent') {
                    <ng-container
                        [ngTemplateOutlet]="C4MeTxtSvgCtaComponent"
                    ></ng-container>
                }
                @case ('HeSvgListComponent') {
                    <ng-container
                        [ngTemplateOutlet]="HeSvgListComponent"
                    ></ng-container>
                }
                @case ('headerClearV2') {
                    <ng-container
                        [ngTemplateOutlet]="headerClearV2"
                    ></ng-container>
                }
                @case ('ModuloMenuHomeComponent') {
                    <ng-container
                        [ngTemplateOutlet]="moduloMenuHomeComponent"
                    ></ng-container>
                }
                @case ('BabylonHeMeSvgTextCtaMot') {
                    <ng-container
                        [ngTemplateOutlet]="BabylonHeMeSvgTextCtaMot"
                    ></ng-container>
                }
            }
        </div>
    }
}

<main
    class="main-cotainer"
    [ngClass]="{
        'coming-soon-page': inComingSoon,
        'submenu-on': submenu$(),
    }"
    [dynamicHeaderPage]="isDynamicHeader"
    [excludedHeaders]="[
        '.lib-babylon-he-me-svg-text-cta-mot',
        '.modulo-menu-home',
    ]"
    [pageDataLoaded]="isPageDataLoaded"
>
    @if (topSlider$() && loadHeaders) {
        @switch (topSlider$()!.name) {
            @case ('topslider') {
                <ng-container
                    [ngTemplateOutlet]="topSlider"
                    [ngTemplateOutletContext]="{ data: topSlider$() }"
                ></ng-container>
            }
            @case ('topslidervideo') {
                <ng-container
                    [ngTemplateOutlet]="topSliderVideo"
                    [ngTemplateOutletContext]="{ data: topSlider$() }"
                ></ng-container>
            }
            @case ('topsliderthumbs') {
                <ng-container
                    [ngTemplateOutlet]="topSliderThumbs"
                    [ngTemplateOutletContext]="{ data: topSlider$() }"
                ></ng-container>
            }
            @case ('topslidervideov2') {
                <ng-container
                    [ngTemplateOutlet]="topSliderVideoV2"
                    [ngTemplateOutletContext]="{ data: topSlider$() }"
                ></ng-container>
            }
        }
    } @else {
        @if (loadHeaders) {
            <ng-container [ngTemplateOutlet]="topSlider"></ng-container>
        }
    }
    <ng-content></ng-content>
    <lib-babylon-floating-buttons
        [floatingButtons]="headerData?.floatingButtons"
    ></lib-babylon-floating-buttons>
</main>

@if (mostrarColorPicker) {
    <lib-babylon-color-picker
        #colorPickerRef
        [hidden]="!mostrarColorPicker"
    ></lib-babylon-color-picker>
}

@if (!inComingSoon) {
    <div class="footers__container">
        @if ($folislinks(); as folislinksData) {
            @if (folislinksData?.props; as props) {
                @if (loadFooter) {
                    <ng-container
                        [ngTemplateOutlet]="folislinks"
                        [ngTemplateOutletContext]="{ data: folislinksData }"
                    ></ng-container>
                }
            }
        }
        @if ($foc3imgtxt(); as foc3imgtxtData) {
            @if (foc3imgtxtData?.props; as props) {
                @if (loadFooter) {
                    <ng-container
                        [ngTemplateOutlet]="foc3imgtxt"
                        [ngTemplateOutletContext]="{ data: foc3imgtxtData }"
                    ></ng-container>
                }
            }
        }

        @if ($foC0SvgLink(); as foC0svglinkData) {
            @if (foC0svglinkData?.props; as props) {
                @if (loadFooter) {
                    <ng-container
                        [ngTemplateOutlet]="foc0svglink"
                        [ngTemplateOutletContext]="{ data: foC0svglinkData }"
                    ></ng-container>
                }
            }
        }

        @if ($foc3txticov2(); as foC3txticoV2Data) {
            @if (foC3txticoV2Data?.props; as props) {
                @if (loadFooter) {
                    <ng-container
                        [ngTemplateOutlet]="foc3txticoV2"
                        [ngTemplateOutletContext]="{ data: foC3txticoV2Data }"
                    ></ng-container>
                }
            }
        }

        @if ($footer(); as footerData) {
            @if (footerData?.props; as props) {
                <!--Defer when data loaded-->
                @if (loadFooter) {
                    @if (footerData.name.toLowerCase() === 'staticfooter') {
                        <ng-container
                            [ngTemplateOutlet]="staticfooter"
                            [ngTemplateOutletContext]="{ data: footerData }"
                        ></ng-container>
                    } @else if (
                        footerData.name.toLowerCase() === 'staticfooterv2'
                    ) {
                        <ng-container
                            [ngTemplateOutlet]="staticfooterv2"
                            [ngTemplateOutletContext]="{ data: footerData }"
                        ></ng-container>
                    } @else if (
                        footerData.name.toLowerCase() === 'staticfooterv3'
                    ) {
                        <ng-container
                            [ngTemplateOutlet]="staticfooterv3"
                            [ngTemplateOutletContext]="{ data: footerData }"
                        ></ng-container>
                    } @else if (
                        footerData.name.toLowerCase() === 'staticfooterv4'
                    ) {
                        <ng-container
                            [ngTemplateOutlet]="staticfooterv4"
                            [ngTemplateOutletContext]="{ data: footerData }"
                        ></ng-container>
                    } @else if (
                        footerData.name.toLowerCase() === 'foc3txtsvgcta'
                    ) {
                        <ng-container
                            [ngTemplateOutlet]="foc3txtsvgcta"
                            [ngTemplateOutletContext]="{ data: footerData }"
                        ></ng-container>
                    } @else if (
                        footerData.name.toLowerCase() === 'folisc4txt'
                    ) {
                        <ng-container
                            [ngTemplateOutlet]="folisc4txt"
                            [ngTemplateOutletContext]="{ data: footerData }"
                        ></ng-container>
                    } @else if (
                        footerData.name.toLowerCase() === 'c4folinksvg'
                    ) {
                        <ng-container
                            [ngTemplateOutlet]="c4folinksvg"
                            [ngTemplateOutletContext]="{ data: footerData }"
                        ></ng-container>
                    }
                }
            }
        }
        @if ($footerContact(); as footerContactData) {
            @if (footerContactData?.props; as props) {
                @if (loadFooter) {
                    <ng-container
                        [ngTemplateOutlet]="footerContact"
                        [ngTemplateOutletContext]="{ data: footerContactData }"
                    ></ng-container>
                }
            }
        }

        @if ($footerLogos(); as footerLogosData) {
            @if (footerLogosData?.props; as props) {
                @if (loadFooter) {
                    <ng-container
                        [ngTemplateOutlet]="footerlogos"
                        [ngTemplateOutletContext]="{ data: footerLogosData }"
                    ></ng-container>
                }
            }
        }

        @if ($footerLinks(); as footerLinksData) {
            @if (footerLinksData?.props; as props) {
                @if (loadFooter) {
                    <ng-container
                        [ngTemplateOutlet]="footerlinks"
                        [ngTemplateOutletContext]="{ data: footerLinksData }"
                    ></ng-container>
                }
            }
        }
    </div>
}

<ng-template #breadcrumbs>
    @if (breadcrumbs$(); as breadcrumbs) {
        <div [ngClass]="{ 'breadcrumbs-wrapper': !isDynamicHeader }">
            <lib-babylon-breadcrumb [links]="breadcrumbs.links">
            </lib-babylon-breadcrumb>
        </div>
    }
</ng-template>

<ng-template #breadcrumbsv2>
    @if (breadcrumbsv2$(); as breadcrumbs) {
        <div [ngClass]="{ 'breadcrumbs-wrapper': !isDynamicHeader }">
            <lib-babylon-breadcrumb-v2 [links]="breadcrumbs.links">
            </lib-babylon-breadcrumb-v2>
        </div>
    }
</ng-template>

<ng-template #engineRef>
    @if (engine && isBookingEngineEnabled) {
        <lib-babylon-engine
            [button]="engine.button"
            [datepickerData]="engine.datepickerData"
            [guestsInput]="engine.guestsInput"
            [guests]="engine.guests"
            [promoInput]="engine.promoInput"
            [title]="engine.title"
            [subtitle]="engine.subtitle"
            [hotelsInput]="engine.hotelsInput"
            [hotels]="engine.hotels"
            [hotelsPlaceholder]="engine.hotelsPlaceholder"
            [onlyAdults]="engine.onlyAdults"
            [defaultButton]="engine.defaultButton"
            [class.engine__headerClear]="
                headerVersion === 'headerClearEngineShow'
            "
            [class.engine__headerMenuShow]="
                headerVersion === 'headerMenuShowEngineShow'
            "
            [openInNewWindow]="openInNewWindow"
            [multipleMotorsModal]="multipleMotorsModal"
            (openModalMultMotors)="openModalMultMotors()"
        ></lib-babylon-engine>
    }
</ng-template>

<ng-template #topSlider let-data="data">
    @if (data?.props || engine) {
        <div class="top-container">
            @if (data?.props) {
                <lib-babylon-top-slider
                    [buttons]="data.props.buttons"
                    [items]="data.props.items"
                    [logo]="data.props.logo"
                    [logoTitle]="data.props.logoTitle"
                    [itemsMobile]="data.props.itemsMobile"
                    [tags]="data.props.tags"
                    [textColors]="data.props.textColors"
                    [videoData]="data.props.videoData"
                    [autoplayDelay]="5000"
                    (modalClick)="onOpenGlobalModal($event)"
                ></lib-babylon-top-slider>
            }
            @if (
                headerVersion !== 'headerClearEngineShow' &&
                headerVersion !== 'headerMenuShowEngineShow'
            ) {
                <ng-container [ngTemplateOutlet]="engineRef"></ng-container>
            }
        </div>
    }
    <ng-container [ngTemplateOutlet]="breadcrumbs"></ng-container
    ><ng-container [ngTemplateOutlet]="breadcrumbsv2"></ng-container>
</ng-template>

<ng-template #topSliderThumbs let-data="data">
    @if (data?.props || engine) {
        <div class="top-container">
            @if (data?.props; as props) {
                <lib-babylon-top-slider-thumbs
                    [title]="props.title"
                    [from]="props.from"
                    [price]="props.price"
                    [currency]="props.currency"
                    [images]="props.image"
                ></lib-babylon-top-slider-thumbs>
            }

            @if (
                headerVersion !== 'headerClearEngineShow' &&
                headerVersion !== 'headerMenuShowEngineShow'
            ) {
                <ng-container [ngTemplateOutlet]="engineRef"></ng-container>
            }
        </div>

        <ng-container [ngTemplateOutlet]="breadcrumbs"></ng-container
        ><ng-container [ngTemplateOutlet]="breadcrumbsv2"></ng-container>
    }
</ng-template>

<ng-template #topSliderVideo let-data="data">
    @if (data?.props || engine) {
        <div class="top-container">
            @if (data?.props) {
                <lib-babylon-top-slider-video
                    [labelInfos]="data.props.labelInfos"
                    [videoData]="data.props.videoData"
                    [smallVideoData]="data.props.smallVideoData"
                    [button]="data.props.button"
                    [img]="data.props.img"
                    [tags]="data.props.tags"
                    [textColors]="data.props.textColors"
                ></lib-babylon-top-slider-video>
            }
            @if (
                headerVersion !== 'headerClearEngineShow' &&
                headerVersion !== 'headerMenuShowEngineShow'
            ) {
                <ng-container [ngTemplateOutlet]="engineRef"></ng-container>
            }
        </div>

        <ng-container [ngTemplateOutlet]="breadcrumbs"></ng-container
        ><ng-container [ngTemplateOutlet]="breadcrumbsv2"></ng-container>
    }
</ng-template>

<ng-template #topSliderVideoV2 let-data="data">
    @if (data?.props || engine) {
        <div class="top-container">
            @if (data?.props) {
                <lib-babylon-top-slider-video-v2
                    [texts]="data.props.texts"
                ></lib-babylon-top-slider-video-v2>
            }
            @if (
                headerVersion !== 'headerClearEngineShow' &&
                headerVersion !== 'headerMenuShowEngineShow'
            ) {
                <ng-container [ngTemplateOutlet]="engineRef"></ng-container>
            }
        </div>

        <ng-container [ngTemplateOutlet]="breadcrumbs"></ng-container
        ><ng-container [ngTemplateOutlet]="breadcrumbsv2"></ng-container>
    }
</ng-template>

<ng-template #headerBookShow>
    @if (headerData) {
        <lib-babylon-header-book-show
            [ngClass]="{ advantages_up: advantagesUp }"
            [btnBook]="headerData | btnBook: isBookingEngineEnabled"
            [lang]="headerData.lang"
            [menu]="headerData.menu"
            [menuInfo]="headerData.menuInfo"
            [linkLogo]="headerData.linkLogo"
            [logos]="logos"
            [menuInfo]="headerData.menuInfo"
            (openEngine)="openEngineModal()"
            (openLanguages)="openLanguagesModal(1)"
            (modalClick)="onOpenGlobalModal($event)"
            (openModalMultMotors)="openModalMultMotors()"
        ></lib-babylon-header-book-show>
    }
</ng-template>

<ng-template #headerClear let-engineShow="engineShow">
    @if (headerData2) {
        <lib-babylon-header-clear
            [btnBook]="headerData2 | btnBook: isBookingEngineEnabled"
            [shop]="headerData2.shop"
            [links]="headerData2.links"
            [engineExtern]="engine_extern"
            [lang]="headerData2.lang"
            [menu]="headerData2.menu"
            [menuInfo]="headerData2.menuInfo"
            [linkLogo]="headerData2.linkLogo"
            [logos]="logos"
            [engineShow]="engineShow"
            [buttonShow]="booking_button_engine_enabled"
            [engineRef]="engineRef"
            (openEngine)="openEngineModal()"
            (openLanguages)="openLanguagesModal(1)"
            (openNews)="openNewsletterModal()"
            (modalClick)="onOpenGlobalModal($event)"
            (openModalMultMotors)="openModalMultMotors()"
        ></lib-babylon-header-clear>
    }
</ng-template>

<ng-template #headerMenuCenter>
    @if (headerData3) {
        <lib-babylon-header-menu-center
            [btnBook]="headerData3 | btnBook: !isBookingEngineEnabled"
            [shop]="headerData3.shop"
            [links]="headerData3.links"
            [engineExtern]="engine_extern"
            [lang]="headerData3.lang"
            [menu]="headerData3.menu"
            [menuInfo]="headerData3.menuInfo"
            [linkLogo]="headerData3.linkLogo"
            [logo]="logos.logoDesktop"
            [logoSticky]="logos.logo"
            (openEngine)="openEngineModal()"
            (openLanguages)="openLanguagesModal(1)"
            (modalClick)="onOpenGlobalModal($event)"
            (openModalMultMotors)="openModalMultMotors()"
        ></lib-babylon-header-menu-center>
    }
</ng-template>

<ng-template #headerMenuShow let-engineShow="engineShow">
    @if (headerData4) {
        <lib-babylon-header-menu-show
            [btnBook]="headerData4 | btnBook: isBookingEngineEnabled"
            [lang]="headerData4.lang"
            [menu]="headerData4.menu"
            [menuInfo]="headerData4.menuInfo"
            [linkLogo]="headerData4.linkLogo"
            [logos]="logos"
            [engineShow]="engineShow"
            [engineRef]="engineRef"
            (openEngine)="openEngineModal()"
            (openLanguages)="openLanguagesModal(1)"
            (openNews)="openNewsletterModal()"
            (modalClick)="onOpenGlobalModal($event)"
            (openModalMultMotors)="openModalMultMotors()"
        ></lib-babylon-header-menu-show>
    }
</ng-template>

<ng-template #headerCenterBookShow>
    @if (headerData5) {
        <lib-babylon-header-menu-logo-center
            [lang]="headerData5.lang"
            [menu]="headerData5.menu"
            [menuInfo]="headerData5.menuInfo"
            [btnBook]="headerData5 | btnBook: isBookingEngineEnabled"
            [linkLogo]="linkLogo"
            [logos]="logos"
            (openEngine)="openEngineModal()"
            (openLanguages)="openLanguagesModal(1)"
            (modalClick)="onOpenGlobalModal($event)"
            (openModalMultMotors)="openModalMultMotors()"
        ></lib-babylon-header-menu-logo-center>
    }
</ng-template>

<ng-template #C4MeTxtSvgCtaComponent>
    @if (headerData5) {
        <ces-c4-me-txt-svg-cta
            [texts]="headerData5.texts"
            [languages]="languagesData"
            [title]="headerData5.title"
            [menu]="headerData5.menu"
            [logos]="logos"
            [linkHome]="linkHome"
            [menuInfo]="headerData5.menuInfo"
            [linkLogo]="linkLogo"
            (openEngine)="openEngineModal()"
            (openLanguages)="openLanguagesModal(1)"
            (modalClick)="onOpenGlobalModal($event)"
            (openModalMultMotors)="openModalMultMotors()"
        ></ces-c4-me-txt-svg-cta>
    }
</ng-template>

<ng-template #HeSvgListComponent>
    @if (headerData7) {
        <lib-babylon-he-svg-list
            class="lib-babylon-he-svg-list"
            [dinamyHeader]="isDynamicHeader"
            [hotelPage]="pageType"
            [logos]="logos"
            [links]="headerData7.links"
            [menu]="headerData7.menu"
            [widgetConfig]="widgetConfig"
            [ticker]="ticker$()?.bodyextra?.nameIdentifier"
            [locale]="languagesData?.selected?.code"
            [floatingButtons]="headerData7.floatingButtons"
            (openLanguages)="openLanguagesModal(3)"
            (openOfferPop)="onOpenGlobalModal($event)"
            [hotel]="submenu$() ? submenu$()?.hotel! : 'hotel'"
            [items]="submenu$() ? submenu$()?.items! : undefined"
            [selected]="submenu$() ? submenu$()?.selected : undefined"
            [styles]="submenu$() ? submenu$()?.styles : undefined"
            [hotelType]="hotelType$()"
            [hotelCategory]="hotelCategory$()"
        ></lib-babylon-he-svg-list>
    }
</ng-template>
<ng-template #headerClearV2>
    @if (headerData2) {
        <lib-babylon-header-clear-v2
            [btnBook]="headerData2 | btnBook: isBookingEngineEnabled"
            [shop]="headerData2.shop"
            [links]="headerData2.links"
            [engineExtern]="engine_extern"
            [lang]="headerData2.lang"
            [menu]="headerData2.menu"
            [menuInfo]="headerData2.menuInfo"
            [linkLogo]="headerData2.linkLogo"
            [logos]="logos"
            [buttonShow]="booking_button_engine_enabled"
            [engineRef]="engineRef"
            (openLanguages)="openLanguagesModal(2)"
        ></lib-babylon-header-clear-v2>
    }
</ng-template>

<ng-template #moduloMenuHomeComponent>
    @if (headerData7) {
        <modulo-menu-home
            class="modulo-menu-home"
            [dinamyHeader]="isDynamicHeader"
            [locale]="languagesData?.selected?.code"
            [hotelPage]="pageType"
            [logos]="logos"
            [links]="headerData7.links"
            [languages]="languagesData"
            [menu]="headerData7.menu"
            [widgetConfig]="widgetConfig"
            [ticker]="ticker$()?.bodyextra?.nameIdentifier"
            [floatingButtons]="headerData7.floatingButtons"
            [hotel]="submenu$() ? submenu$()?.hotel! : undefined"
            [items]="submenu$() ? submenu$()?.items! : undefined"
            [selected]="submenu$() ? submenu$()?.selected : undefined"
            [roomsModal]="roomsModal$()?.[0]?.props"
            [styles]="submenu$() ? submenu$()?.styles : undefined"
            [hotelType]="hotelType$()"
            [hotelCategory]="hotelCategory$()"
            (languageSelect)="updateLanguage($event)"
        ></modulo-menu-home>
    }
</ng-template>

<ng-template #BabylonHeMeSvgTextCtaMot>
    @if (headerData7) {
        <lib-babylon-he-me-svg-text-cta-mot
            class="lib-babylon-he-me-svg-text-cta-mot"
            [menu]="headerData7.menu"
            [logos]="logos"
            [dinamyHeader]="isDynamicHeader"
            [logos]="logos"
            [links]="headerData7.links"
            [menu]="headerData7.menu"
            [widgetConfig]="widgetConfig"
            [ticker]="ticker$()?.bodyextra?.nameIdentifier"
            [locale]="languagesData?.selected?.code"
            [floatingButtons]="headerData7.floatingButtons"
            [headerData]="headerData7"
            (openEngine)="openEngineModal()"
            (openLanguages)="openLanguagesModal(1)"
            (openNews)="openNewsletterModal()"
            (openSelectorModal)="openSelectorModal($event)"
        ></lib-babylon-he-me-svg-text-cta-mot>
    }
</ng-template>

<ng-template #staticfooter let-data="data">
    @if (data?.props; as props) {
        <lib-babylon-static-footer
            [title]="props.title"
            [ndTitle]="props.ndTitle"
            [rdTitle]="props.rdTitle"
            [thTitle]="props.thTitle"
            [fifthTitle]="props.fifthTitle"
            [ahTitle]="props.ahTitle"
            [frameUrl]="props.frameUrl"
            [contactInfo]="props.contactInfo"
            [contactLinks]="props.contactLinks"
            [footerLinks]="props.footerLinks"
            [address]="props.address[0]"
            [addressHotels]="props.addressHotels"
            [socialMedia]="props.socialMedia"
            [copyright]="props.copyright"
            [nav]="props.nav"
            [img]="props.img"
            [logo]="props.logo"
            [legalAdvise]="props.legalAdvise"
            [input]="props.input"
            [additionalLinks]="props.additionalLinks"
            (submitForm)="sendNewsletterFooter($event)"
        ></lib-babylon-static-footer>
    }
</ng-template>

<ng-template #staticfooterv2 let-data="data">
    @if (data?.props; as props) {
        <lib-babylon-static-footer-v2
            [title]="props.title"
            [ndTitle]="props.ndTitle"
            [rdTitle]="props.rdTitle"
            [thTitle]="props.thTitle"
            [imgUrl]="props?.imgUrl"
            [frameUrl]="props.frameUrl"
            [contactInfo]="props.contactInfo"
            [contactLinks]="props.contactLinks"
            [address]="props.address[0]"
            [socialMedia]="props.socialMedia"
            [copyright]="props.copyright"
            [nav]="props.nav"
            [footerLinks]="props.footerLinks"
            [img]="props.img"
        ></lib-babylon-static-footer-v2>
    }
</ng-template>

<ng-template #staticfooterv3 let-data="data">
    @if (data?.props; as props) {
        <lib-babylon-static-footer-v3
            [texts]="props.texts"
            [multimedia]="props.multimedia"
            [links]="props.links"
            [address]="props.address"
        >
        </lib-babylon-static-footer-v3>
    }
</ng-template>

<ng-template #staticfooterv4 let-data="data">
    @if (data?.props; as props) {
        <lib-babylon-static-footer-v4
            [address]="props.address"
            [addressHotels]="props.addressHotels"
            [texts]="props.texts"
            [buttons]="props.buttons"
            (submitForm)="sendNewsletterFooter($event)"
        >
        </lib-babylon-static-footer-v4>
    }
</ng-template>

<ng-template #footerContact let-data="data">
    @if (data?.props) {
        <lib-babylon-footer-contact
            [title]="data.props.title"
            [text]="data.props.text"
            [extraTxt]="data.props.extraTxt"
            [button]="data.props.button"
            [img]="data.props.img"
            [advantages]="data.props.advantages"
            [links]="data.props.links"
            [address]="data.props.address"
        ></lib-babylon-footer-contact>
    }
</ng-template>

<ng-template #footerlogos let-data="data">
    @if (data.props) {
        <lib-babylon-footer-logos
            [logos]="data.props.logos"
            [texts]="data.props.texts"
            [buttons]="data.props.buttons"
        ></lib-babylon-footer-logos>
    }
</ng-template>

<ng-template #footerlinks let-data="data">
    @if (data?.props) {
        <lib-babylon-footer-links
            [copyright]="data.props.copyright"
            [year]="data.props.year"
            [buttons]="data.props.buttons"
        ></lib-babylon-footer-links>
    }
</ng-template>

<ng-template #folisc4txt let-data="data">
    @if (data?.props; as props) {
        <lib-babylon-fo-lis-c4-txt
            class="lib-babylon-fo-lis-c4-txt"
            [texts]="props.texts"
            [multimedia]="props.multimedia"
            [buttons]="props.buttons"
            [styles]="submenu$() ? submenu$()?.styles : undefined"
        ></lib-babylon-fo-lis-c4-txt>
    }
</ng-template>

<ng-template #foc3txtsvgcta let-data="data">
    @if (data?.props; as props) {
        <lib-babylon-fo-c3-txt-svg-cta
            class="lib-babylon-fo-c3-txt-svg-cta"
        ></lib-babylon-fo-c3-txt-svg-cta>
    }
</ng-template>

<ng-template #foc0svglink let-data="data">
    @if (data?.props; as props) {
        <fo-c0-svg-link
            [texts]="props.texts"
            [footerLinks]="props.footerLinks"
        ></fo-c0-svg-link>
    }
</ng-template>

<ng-template #c4folinksvg let-data="data">
    @if (data?.props; as props) {
        <ces-c4-fo-link-svg
            [multimedia]="props.multimedia"
            [texts]="props.texts"
            [footerLinks]="props.footerLinks"
            [socialMedia]="props.socialMedia"
        ></ces-c4-fo-link-svg>
    }
</ng-template>

<ng-template #folislinks let-data="data">
    @if (data?.props; as props) {
        <lib-babylon-lis-link-cleans
            class="lib-babylon-lis-link-cleans"
            [links]="props.buttons"
        ></lib-babylon-lis-link-cleans>
    }
</ng-template>

<ng-template #foc3imgtxt let-data="data">
    @if (data?.props; as props) {
        <lib-babylon-fo-c3-img-txt
            class="lib-babylon-fo-c3-img-txt"
            [multimedia]="props.multimedia"
            [texts]="props.texts"
        ></lib-babylon-fo-c3-img-txt>
    }
</ng-template>

<ng-template #foc3txticoV2 let-data="data">
    @if (data?.props; as props) {
        <fo-c3-txt-ico-v2
            [texts]="props.texts"
            [footerLinks]="props.footerLinks"
            [socialMedia]="getFilteredSocialMedia(props)"
            [buttons]="props.buttons"
            [multimedia]="props.multimedia"
        ></fo-c3-txt-ico-v2>
    }
</ng-template>
